import React, { useState } from 'react';
import classNames from 'classnames';

import { FiPlus } from 'react-icons/fi';

import Empty from 'components/common/empty/Empty';
import type { OverlaySkill } from 'components/common/skills/types';

import SkillList from 'pages/settings/skills/components/SkillList';

import { SkillNode } from 'interface/skillTree';
import type { GlobalRatingItem } from 'pages/settings/skills/types';

interface Props {
  showAddSkills?: boolean;
  openEditCategoryModal: (category: SkillNode) => void;
  openAddSkillModal: (parentData: SkillNode[]) => void;
  openEditSkillModal: (skillData: SkillNode, parentData: SkillNode[]) => void;
  selectedCategory: SkillNode;
  globalRatings?: GlobalRatingItem[];
  selectedSkills?: SkillNode[] | null;
  onSelectedSkillsChange?: (skills: SkillNode[]) => void;
  skillListClass?: string;
  setIsOverlayOpenFor?: (skill: OverlaySkill<SkillNode> | null) => void;
  isOpenFor?: OverlaySkill<SkillNode> | number | string | null;
  isSelf?: boolean;
  isTeamManager?: boolean;
}

const SkillCategoryChild: React.FC<Props> = (props) => {
  const {
    showAddSkills,
    openEditCategoryModal,
    openAddSkillModal,
    openEditSkillModal,
    selectedCategory,
    globalRatings,
    selectedSkills,
    onSelectedSkillsChange,
    skillListClass,
    setIsOverlayOpenFor,
    isOpenFor,
    isSelf,
    isTeamManager,
  } = props;

  const [ratingOpenFor, setRatingOpenFor] = useState<number | string | null>(null);

  const parentData = [selectedCategory];

  return (
    <>
      <div className="skill-category-header">
        <div
          className={classNames('skill-category-header__text', {
            'skill-category-header__text--clickable': showAddSkills,
          })}
          onClick={() => showAddSkills && openEditCategoryModal(selectedCategory)}
        >
          {selectedCategory.name}
        </div>
        {showAddSkills && (
          <button
            className="skill-category-header__btn d-flex align-items-center"
            onClick={() => openAddSkillModal([selectedCategory])}
          >
            <div className="mtpx-2 mrpx-6">
              <FiPlus color="#29B6F6" size={14} />
            </div>
            <div>Add Skill</div>
          </button>
        )}
      </div>
      <div className={classNames('skills-list', skillListClass)}>
        {!selectedCategory.subSkills?.length && (
          <div className="skills-list__empty-container">
            <Empty message="Added skills will show up here.">
              {showAddSkills && (
                <button
                  type="button"
                  className={classNames('btn btn--outlined-grey btn--curved mr-10')}
                  onClick={() => openAddSkillModal([selectedCategory])}
                >
                  Add Skill
                </button>
              )}
            </Empty>
          </div>
        )}

        {!!selectedCategory.subSkills.length &&
          selectedCategory.subSkills.map((firstSkill) => {
            return (
              <SkillList
                key={firstSkill.id}
                skill={firstSkill}
                parentData={parentData}
                openAddSkillModal={openAddSkillModal}
                openEditSkillModal={openEditSkillModal}
                showAddSkills={showAddSkills}
                globalRatings={globalRatings}
                selectedSkills={selectedSkills}
                onSelectedSkillsChange={onSelectedSkillsChange}
                setIsOverlayOpenFor={setIsOverlayOpenFor}
                isOpenFor={isOpenFor}
                isSelf={isSelf}
                isTeamManager={isTeamManager}
                ratingOpenFor={ratingOpenFor}
                setRatingOpenFor={setRatingOpenFor}
              />
            );
          })}
      </div>
    </>
  );
};

export default SkillCategoryChild;
